import { useErrorHandlerContext } from "@context-providers/error-handler/error-handler-context";
import { useToast } from "@flat-ui";
import { QueryParams } from "@router/route-params";
import { runtimeConfig } from "@src/runtime-config";
import { AppRegion } from "@src/runtime-config-types";
import { redirectClient } from "@utils/client-utils";
import { isValidUlmClient } from "@utils/ulm-utils";
import { useSearchParams } from "react-router-dom";

/** Map of the ULM base URL of the other region */
const OTHER_SERVER_ORIGIN: Record<AppRegion, string> = {
  com: runtimeConfig.urls.sphereEntryPageEuUrl,
  eu: runtimeConfig.urls.sphereEntryPageComUrl,
};

/** The ULM base URL of the other region */
const NEW_ORIGIN = OTHER_SERVER_ORIGIN[runtimeConfig.appRegion];

/** Returns a function to redirect the user to the same URL in the other server */
export function useRedirectToOtherServer(): () => void {
  const { openToast, closeToast } = useToast();
  const { handleError } = useErrorHandlerContext();
  const [searchParams] = useSearchParams();

  const clientParam = searchParams.get(QueryParams.client);
  const client = isValidUlmClient(clientParam) ? clientParam : "default";

  function redirectToOtherServer(): void {
    const toastKey = openToast({
      title: "You are being redirected...",
      variant: "neutral",
    });

    try {
      const url = new URL(window.location.href);
      const newUrl = new URL(url.pathname + url.search, NEW_ORIGIN);

      redirectClient({
        client,
        redirectUrl: newUrl.href,
      });
    } catch (error) {
      closeToast(toastKey);
      handleError({
        id: `redirectToOtherServer-${Date.now().toString()}`,
        title: "An error occurred during redirection.",
        error,
        uiType: "toast",
      });
    }
  }

  return redirectToOtherServer;
}
